import React from "react";
import { formatNumber } from "utils/currencyFormat";

/** Ép về số để tránh NaN khi API trả thiếu trường */
const n = (v) => Number(v) || 0;

/** Tỷ trọng an toàn: mẫu số 0 (khoảng search không có dữ liệu) -> 0% thay vì NaN% */
const tyLe = (phan, tong) =>
  tong ? `${Math.round((100 * phan) / tong)}%` : "0%";

export const TableThongKeMoney88 = ({
  tongSoCamDo,
  tongSoTinChap,
  tongSoTraGop,
  tongTienCamDo,
  tongTienTinChap,
  tongTienVayHo,
  tongCamDoLaiDaThu,
  tongTinChapLaiDaThu,
  tongLaiHoLaiDaThu,
  tongCamDoLaiTrongThang,
  tongTinChapLaiTrongThang,
  tongLaiHoLaiTrongThang,
  TongTienBHTraGop,
  TongLaiBHTraGopDaThu,
  TongSoBHTraGop,
  TongLaiBHTraGopTrongThang,
  isBanHangTraGop,
  nhanKhoang,
  nhanDenNgay,
  nhanKhoangLaiTrongKy,
}) => {
  // Bán hàng trả góp chỉ được cộng vào tổng khi công ty có bật tính năng này
  const soBHTraGop = isBanHangTraGop ? n(TongSoBHTraGop) : 0;
  const tienBHTraGop = isBanHangTraGop ? n(TongTienBHTraGop) : 0;
  const laiDaThuBHTraGop = isBanHangTraGop ? n(TongLaiBHTraGopDaThu) : 0;
  const laiTrongKyBHTraGop = isBanHangTraGop ? n(TongLaiBHTraGopTrongThang) : 0;

  const tongSoHD =
    n(tongSoCamDo) + n(tongSoTinChap) + n(tongSoTraGop) + soBHTraGop;

  const tongDangChoVay =
    n(tongTienCamDo) + n(tongTienTinChap) + n(tongTienVayHo) + tienBHTraGop;

  const tongLaiDaThu =
    n(tongCamDoLaiDaThu) +
    n(tongTinChapLaiDaThu) +
    n(tongLaiHoLaiDaThu) +
    laiDaThuBHTraGop;

  const tongLaiTrongKy =
    n(tongCamDoLaiTrongThang) +
    n(tongTinChapLaiTrongThang) +
    n(tongLaiHoLaiTrongThang) +
    laiTrongKyBHTraGop;

  return (
    <div className="table-home-new">
      <div className="row">
        <div className="col-12" style={{ padding: "0px" }}>
          <div className="card">
            <div className="card-content">
              <div className="card-body">
                <div
                  className="table-wrapper"
                  style={{
                    // border: "10px solid #f0f0f0",
                    borderRadius: "10px",
                    overflowX: "auto", // quan trọng
                    width: "100%",
                  }}
                >
                  <table className="table">
                    <thead style={{ background: "#E6F5F5" }}>
                      <tr
                        style={{
                          padding: "0 0 10px 0",
                          color: "#1e2a47",
                          fontWeight: 700,
                        }}
                      >
                        <th scope="col"></th>

                        <th className="text-right">
                          Số hợp đồng đang vay
                          <br />
                          <small className="color7" style={{ fontWeight: 400 }}>
                            Ngày vay: {nhanKhoang}
                          </small>
                          <br />
                          <span className="color7-bold">{tongSoHD}</span>
                        </th>

                        <th className="text-right">
                          Tổng đang cho vay
                          <br />
                          <small className="color7" style={{ fontWeight: 400 }}>
                            Ngày vay: {nhanKhoang}
                          </small>
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(tongDangChoVay)}
                          </span>
                        </th>

                        <th className="text-right">
                          Tổng lãi đã thu
                          <br />
                          <small className="color7" style={{ fontWeight: 400 }}>
                            Lũy kế đến {nhanDenNgay}
                          </small>
                          <br />
                          <span className="color-cam-bold">
                            {formatNumber(tongLaiDaThu)}
                          </span>
                        </th>
                        <th className="text-right">
                          Lãi trong kỳ
                          <br />
                          <small className="color7" style={{ fontWeight: 400 }}>
                            {nhanKhoangLaiTrongKy || nhanKhoang}
                          </small>
                          <br />
                          <span className="color-do-bold">
                            {formatNumber(tongLaiTrongKy)}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">
                          <span
                            className="img-home-new"
                            style={{ marginLeft: "5rem" }}
                          >
                            <img src="app-assets/images/icon-cam-do-v2.png"></img>
                          </span>
                          <span>Cầm đồ</span>
                        </th>
                        <td className="text-right">
                          <span className="color7-bold">{tongSoCamDo}</span>
                        </td>
                        <td className="text-right ">
                          <a href="/trang-chu/cam-do.aspx">
                            <span className="color-xanh-bold btn-link">
                              {" "}
                              {formatNumber(tongTienCamDo)}
                            </span>
                          </a>

                          <br />
                          <span className="color7">
                            {tyLe(n(tongTienCamDo), tongDangChoVay)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-cam-bold">
                            {formatNumber(tongCamDoLaiDaThu)}
                          </span>
                          <br />
                          <span className="color7">
                            {tyLe(n(tongCamDoLaiDaThu), tongLaiDaThu)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-do-bold">
                            {formatNumber(tongCamDoLaiTrongThang)}
                          </span>
                          <br />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <span
                            className="img-home-new"
                            style={{ marginLeft: "5rem" }}
                          >
                            <img src="app-assets/images/icon-tin-chap-v2.png"></img>
                          </span>
                          <span>Tín chấp</span>
                        </th>
                        <td className="text-right">
                          <span className=" color7-bold">{tongSoTinChap}</span>
                        </td>
                        <td className="text-right ">
                          <a href="/trang-chu/tin-chap.aspx">
                            <span className="color-xanh-bold btn-link">
                              {" "}
                              {formatNumber(tongTienTinChap)}{" "}
                            </span>
                          </a>

                          <br />
                          <span className="color7">
                            {tyLe(n(tongTienTinChap), tongDangChoVay)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-cam-bold">
                            {formatNumber(tongTinChapLaiDaThu)}
                          </span>
                          <br />
                          <span className="color7">
                            {tyLe(n(tongTinChapLaiDaThu), tongLaiDaThu)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-do-bold">
                            {formatNumber(tongTinChapLaiTrongThang)}
                          </span>
                          <br />
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <span
                            className="img-home-new"
                            style={{ marginLeft: "5rem" }}
                          >
                            <img src="app-assets/images/tra_gop_icon-02.png"></img>
                          </span>
                          <span>Trả góp</span>
                        </th>
                        <td className="text-right">
                          <span className="color7-bold">{tongSoTraGop}</span>
                        </td>
                        <td className="text-right ">
                          <a href="/trang-chu/tra-gop.aspx">
                            <span className="color-xanh-bold btn-link">
                              {formatNumber(tongTienVayHo)}
                            </span>
                          </a>
                          <br />
                          <span className="color7">
                            {tyLe(n(tongTienVayHo), tongDangChoVay)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-cam-bold">
                            {formatNumber(tongLaiHoLaiDaThu)}
                          </span>
                          <br />
                          <span className="color7">
                            {tyLe(n(tongLaiHoLaiDaThu), tongLaiDaThu)}
                          </span>
                        </td>
                        <td className="text-right">
                          <span className="color-do-bold">
                            {formatNumber(tongLaiHoLaiTrongThang)}
                          </span>
                          <br />
                        </td>
                      </tr>
                      {isBanHangTraGop && (
                        <tr>
                          <th>
                            <span
                              className="img-home-new"
                              style={{ marginLeft: "5rem" }}
                            >
                              <img src="app-assets/images/tra_gop_icon-02.png"></img>
                            </span>
                            <span>Bán hàng trả góp</span>
                          </th>
                          <td className="text-right">
                            <span className="color7-bold">
                              {TongSoBHTraGop}
                            </span>
                          </td>
                          <td className="text-right ">
                            <a href="/trang-chu/ban-hang-tra-gop.aspx">
                              <span className="color-xanh-bold btn-link">
                                {formatNumber(TongTienBHTraGop)}
                              </span>
                            </a>
                            <br />
                            <span className="color7">
                              {tyLe(tienBHTraGop, tongDangChoVay)}
                            </span>
                          </td>
                          <td className="text-right">
                            <span className="color-cam-bold">
                              {formatNumber(TongLaiBHTraGopDaThu)}
                            </span>
                            <br />
                            <span className="color7">
                              {tyLe(laiDaThuBHTraGop, tongLaiDaThu)}
                            </span>
                          </td>
                          <td className="text-right">
                            <span className="color-do-bold">
                              {formatNumber(TongLaiBHTraGopTrongThang)}
                            </span>
                            <br />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
